export enum FundDocumentType {
  KARTY_FUNDUSZY = 'KARTY_FUNDUSZY',
  KLUCZOWE_INFORMACJE_DLA_INWESTOROW = 'KLUCZOWE_INFORMACJE_DLA_INWESTOROW',
  PROSPEKTY_INFORMACYJNE = 'PROSPEKTY_INFORMACYJNE',
  SPRAWOZDANIA_FINANSOWE = 'SPRAWOZDANIA_FINANSOWE',
  INNY = 'INNY',
}
